<template>
  <div class="withdraw-list">
    <a-table
      row-key="id"
      :columns="columns"
      :data-source="listDatas"
      :loading="loading"
      :pagination="false"
      :locale="{
        'emptyText': emptyTip
      }"
    >
      <div
        slot="tips"
        slot-scope="text"
        class="tip"
        :class="{invalid: text.indexOf('!') !== -1}"
        v-html="$xss(text, $xssOptions)"
      />
      <template
        slot="action"
        slot-scope="text,record"
      >
        <a
          href="javascript:;"
          @click="handleEdit(record)"
        >{{ $t('message[36]') }}</a>
        <a
          href="javascript:;"
          @click="handleDelete(record)"
        >{{ $t('message[962]') }}</a>
      </template>
    </a-table>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
  data () {
    return {
    }
  },
  computed: {
    ...mapState('config/autoWithdraw', ['columns', 'listDatas', 'loading']),
    emptyTip () {
      return this.$t('message[1551]')
    }
  },
  async created () {
    await this.fetchRecycleList()
  },
  methods: {
    ...mapActions('config/autoWithdraw', ['fetchRecycleList', 'delRecycle']),

    handleEdit (record) {
      this.$emit('toggleEdit', record.id)
    },
    /**
     * 删除邮件
     */
    async handleDelete (record) {
      this.$confirm({
        title: this.$t('message[1752]'), // 确定要删除当前规则？
        content: this.$t('message[1753]'), // 删除后，该规则不可恢复。
        closable: true,
        okText: this.$t('message[915]'), // 确定
        okType: 'primary',
        cancelText: this.$t('message[896]'), // 取消
        class: 'confirm-warn-modal',
        onOk: async () => {
          const chain = await this.delRecycle({ id: record.id })
          chain
            .onSuccess(res => {
              this.fetchRecycleList()
            })
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
a {
  margin-right: 16px;
}
.tip ::v-deep {
  span {
    color: #f57676;
  }
}
.invalid.tip {
  opacity: .5;
}
</style>
